
interface SvelteComponentScope extends ng.IScope {
    component: any;
    props: any;
    callbacks: { [key: string]: Function };
}

export class SvelteComponent implements ng.IDirective {
    restrict = 'A';
    elementClass = 'svelte-component';
    scope = {
        component: '=',
        props: '=',
        callbacks: '='
    };
    constructor() {
    }

    link($scope: SvelteComponentScope, elem: ng.IAugmentedJQuery,
           attrs: ng.IAttributes): void {
        let componentCls;
        let component: any;


        type Fn = () => void;
        let currentCallbacks: { [key: string]: Fn};

        const updateCallbacks = () => {
            if (!component) return;

            if (currentCallbacks) {
                [...Object.values(currentCallbacks)].forEach(off => off());
            }

            if ($scope.callbacks) {
                currentCallbacks = {};
                for (let [k, cb] of Object.entries($scope.callbacks)) {
                    currentCallbacks[k] = component.$on(k, function () {
                        cb(...arguments);
                        $scope.$root.$digest();
                    });
                }
            }
        };

        function update() {
            if (component && componentCls != attrs.component) {
                component.$destroy();
                component = null;
            }

            const props = $scope.props || {};

            if (!component) {
                componentCls = $scope.component;
                component = new componentCls({
                    target: elem[0],
                    props
                });
            } else {
                component.$set({...props});
            }

            updateCallbacks();
        }

        $scope.$watch('callbacks', updateCallbacks);
        $scope.$watch('props', update);

        requestAnimationFrame(update);
        // update();
    };

    static factory(): ng.IDirectiveFactory {
        const directive = () => new SvelteComponent();
        directive.$inject = [];
        return directive;
    }
}